import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import ProtectedRoute from './ProtectedRoute';  // Custom role-based guard

// Core pages (accessible to all authenticated users)
const DashboardDefault = Loadable(lazy(() => import('views/pages/dashboard/Default')));  // FIXED: lowercase 'dashboard'
const BookingsDefault = Loadable(lazy(() => import('views/pages/Bookings')));  // Your existing; assumes capital 'B'

// Admin-only pages (create these files if missing, as per previous responses)
const SpacesDefault = Loadable(lazy(() => import('views/pages/spaces/Default')));  // lowercase 'spaces'
const UsersDefault = Loadable(lazy(() => import('views/pages/admin/Users/Default')));
const RulesDefault = Loadable(lazy(() => import('views/pages/admin/Rules/Default')));
const SettingsDefault = Loadable(lazy(() => import('views/pages/admin/Settings/Default')));

// NEW: Modern Tailwind + shadcn/ui Admin (Live Production Dashboard)
const ModernAdmin = Loadable(lazy(() => import('admin-modern/ModernAdmin')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  // Pathless layout route: provides AuthGuard + MainLayout for all protected pages.
  // Child paths are matched from the application root (e.g. /dashboard/default, /bookings).
  element: (
    <AuthGuard>  {/* Berry's base auth guard: requires isAuthenticated */}
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    // Dashboard: All users (now with correct path)
    {
      path: 'dashboard/default',
      element: (
        <ProtectedRoute>  {/* Defaults to any role; customize if needed */}
          <DashboardDefault />
        </ProtectedRoute>
      )
    },
    
    // Bookings: All users (admin sees all; users filtered backend-side)
    {
      path: 'bookings',
      element: (
        <ProtectedRoute>
          <BookingsDefault />
        </ProtectedRoute>
      )
    },
    
    // Admin section redirect: '/admin' → '/admin/spaces'
    {
      path: 'admin',
      element: <Navigate to="spaces" replace />
    },
    
    // Spaces Management: Admin only
    {
      path: 'admin/spaces',
      element: (
        <ProtectedRoute adminOnly={true}>
          <SpacesDefault />
        </ProtectedRoute>
      )
    },
    
    // User Management: Admin only
    {
      path: 'admin/users',
      element: (
        <ProtectedRoute adminOnly={true}>
          <UsersDefault />
        </ProtectedRoute>
      )
    },
    
    // Rules Management: Admin only
    {
      path: 'admin/rules',
      element: (
        <ProtectedRoute adminOnly={true}>
          <RulesDefault />
        </ProtectedRoute>
      )
    },
    
    // Settings: Admin only
    {
      path: 'admin/settings',
      element: (
        <ProtectedRoute adminOnly={true}>
          <SettingsDefault />
        </ProtectedRoute>
      )
    },

    // NEW: Modern Admin Experience (Tailwind + shadcn/ui) - Live Production Data
    {
      path: 'admin/live',
      element: (
        <ProtectedRoute adminOnly={true}>
          <ModernAdmin />
        </ProtectedRoute>
      )
    }
  ]
};

export default MainRoutes;